"use client";

import { useLingui } from "@lingui/react";

type MonthCellProps = {
  month: string | null | undefined;
};

export const MonthCell = ({ month }: MonthCellProps) => {
  const { i18n } = useLingui();

  if (!month) {
    return <span className="whitespace-nowrap">-</span>;
  }

  try {
    // month は "YYYY-MM" 形式で来る想定
    const parts = month.split("-");
    if (parts.length !== 2) {
      return <span className="whitespace-nowrap">{month}</span>;
    }

    const year = parts[0];
    const monthNum = parts[1];
    const yearInt = year ? parseInt(year, 10) : NaN;
    const monthInt = monthNum ? parseInt(monthNum, 10) : NaN;

    if (isNaN(yearInt) || isNaN(monthInt) || monthInt < 1 || monthInt > 12) {
      // 無効な形式の場合は元の値を表示
      return <span className="whitespace-nowrap">{month}</span>;
    }

    const date = new Date(yearInt, monthInt - 1, 1);
    const monthLabel = i18n.date(date, {
      year: "numeric",
      month: "short",
    });

    return <span className="whitespace-nowrap">{monthLabel}</span>;
  } catch (_error) {
    // エラーの場合は元の値を表示
    return <span className="whitespace-nowrap">{month}</span>;
  }
};
